export interface TenantEntry {
  id: string;
  name: string;
  legalForm?: string;
  role: string;
  isFavorite: boolean;
  lastUsed: string;
}

const FAVORITES_KEY = 'kontora_tenant_favorites_v1';
const RECENT_KEY = 'kontora_tenant_recents_v1';
const MAX_RECENT = 5;

export function loadFavorites(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY) ?? '[]') as string[];
  } catch {
    return [];
  }
}

export function saveFavorites(ids: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(ids));
  } catch {}
}

export function toggleFavorite(id: string): boolean {
  const favs = loadFavorites();
  const idx = favs.indexOf(id);
  if (idx >= 0) {
    favs.splice(idx, 1);
    saveFavorites(favs);
    return false;
  }
  favs.push(id);
  saveFavorites(favs);
  return true;
}

export function loadRecents(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) ?? '[]') as string[];
  } catch {
    return [];
  }
}

export function markRecent(id: string): void {
  if (typeof window === 'undefined') return;
  const recents = loadRecents().filter((recentId) => recentId !== id);
  recents.unshift(id);
  if (recents.length > MAX_RECENT) recents.pop();
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(recents));
  } catch {}
}

export function filterTenants(tenants: TenantEntry[], query: string): TenantEntry[] {
  if (!query.trim()) return tenants;
  const normalizedQuery = query.trim().toLowerCase();
  return tenants.filter(
    (tenant) =>
      tenant.name.toLowerCase().includes(normalizedQuery) ||
      tenant.legalForm?.toLowerCase().includes(normalizedQuery) ||
      tenant.role.toLowerCase().includes(normalizedQuery),
  );
}

export function sortTenants(tenants: TenantEntry[]): TenantEntry[] {
  return [...tenants].sort((first, second) => {
    if (first.isFavorite && !second.isFavorite) return -1;
    if (!first.isFavorite && second.isFavorite) return 1;
    return new Date(second.lastUsed).getTime() - new Date(first.lastUsed).getTime();
  });
}
